import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, size, space } from '../../theme/tokens';

const fieldHeight = `calc(${primitives.size['size-1000']} + ${space['space-400']} * 2)`;

export const SelectShell = styled.div`
  & > * {
    background: ${semantic.bg.canvas};
    border-radius: ${radius('input', 'radius-md')};
  }

  && > * > * {
    min-height: calc(${fieldHeight} - ${size.stroke['stroke-default']} * 2);
  }

  && div:has(> button[aria-haspopup='listbox']) {
    flex: 1 0 auto;
    justify-content: center;
  }
`;

export const FixedField = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: ${fieldHeight};
  padding: ${space['space-400']} ${space['space-500']};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('input', 'radius-md')};
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  color: ${semantic.text.primary};
`;
